import React from 'react';
import logo from '../../../images/logo.png';
const Navbar = () => {
    return (
        <div className="navbar-area bg-dark">
            <nav className="navbar navbar-expand-lg container navbar-dark">
            <div className="container-fluid">
                <a className="navbar-brand" href="/"><img src={logo} alt="bd-bliss" width="70"/></a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ps-5 ms-5">
                    <li className="nav-item">
                    <a className="nav-link active text-white" aria-current="page" href="/">Home</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link text-white" href="#shop">Shop</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="#blog">Blog</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="#testimonials">Testimonials</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="#contact">Contact</a>
                    </li>
                </ul>
                </div>
            </div>
            </nav>
        </div>
    );
};

export default Navbar;